import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AscendingSvg from '../../components/Form/SortSvg/AscendingSvg';
import DescendingSvg from '../../components/Form/SortSvg/DescendingSvg';
import ModerationLists from './ModerationLists';
import PaymentBlock from './PaymentBlock';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getStats } from '../../redux/actions/dashborad/getStats';
import Skeleton from 'react-loading-skeleton';
import { getVacancyList } from '../../redux/actions/dashborad/getVacancyList';
import { resetGetStats, resetGetVacancyList } from '../../redux/slices/dashboard.slice';
import { filterEmployer } from '../Contractor/ContractorMenu';
import { getEmployerList } from '../../redux/actions/employer/getEmployerList';
import InfiniteScroll from 'react-infinite-scroll-component';
import { format } from 'date-fns';
import VacancyEmpty from '../../components/List/Vacancy/VacancyEmpty';
import { resetGetEmployerList } from '../../redux/slices/employer.slice';
import axios from 'axios';
import { axiosInstance } from '../../utils/axiosInterceptor';
import { Pagination } from 'antd';
import dayjs from 'dayjs';
import clsx from 'clsx';

function DashboardIndex() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    getStats: { data: getStatsData, error: getStatsError, loading: getStatsLoading },
  } = useSelector((state) => state.dashboard);
  const {
    getEmployerList: { data: getEmployerListData, error: getEmployerListError, loading: getEmployerListLoading },
  } = useSelector((state) => state.employer);

  const page = useRef(1);
  const [sortType, setSortType] = useState('date');
  const [sortDirection, setSortDirection] = useState(1); // 1 = ascending, 0 = descending
  const [sortDisplayName, setSortDisplayName] = useState('по дате');
  const [sortDirectionPay, setSortDirectionPay] = useState(1);
  const [items, setItems] = useState([]);

  const [activeTab, setActiveTab] = useState('manager');
  const [activeManagerList, setActiveManagerList] = useState({ loading: true });
  const [activeEmployersList, setActiveEmployersList] = useState({ loading: true });
  const [managerPage, setManagerPage] = useState(1);
  const [employerPage, setEmployerPage] = useState(1);
  useEffect(() => {
    // setActiveManagerList({ loading: true });
    onFetchActivation({ page: managerPage, has_manager: true }).then((list) => {
      setActiveManagerList({ loading: false, data: list });
    });
  }, [managerPage]);
  useEffect(() => {
    // setActiveEmployersList({ loading: true });
    onFetchActivation({ page: employerPage }).then((list) => {
      setActiveEmployersList({ loading: false, data: list });
    });
  }, [employerPage]);

  console.log('activeManagerList', activeManagerList);
  console.log('activeEmployersList', activeEmployersList);

  const onFetchActivation = ({ page, has_manager }) => {
    return axiosInstance
      .get(`${process.env.REACT_APP_SERVER_API}/vacancies/`, {
        params: { page, has_manager, has_unprocessed_applications: true },
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      })
      .then((res) => {
        return res.data;
      });
  };
  useEffect(() => {
    if (getEmployerListData?.results) {
      setItems((prev) => {
        return [
          ...prev,
          ...getEmployerListData?.results?.map((item) => ({
            key: item.id,
            num: item.id,
            name: item.name,
            email: item.email,
            active: item.broadcast_vacancies,
            activeHR: item.broadcast_hr,
            moderation: item.moderation_vacancies,
            inactive: item.inactive_vacancies,
            delete: item.deleted_vacancies,
            date: format(item.created_at, 'HH:mm dd.MM.yy'),
          })),
        ];
      });
    }
  }, [getEmployerListData]);

  useEffect(() => {
    dispatch(getStats({ is_hr: false }));
    dispatch(
      getVacancyList({
        is_active: true,
        is_verified: false,
      }),
    );
    dispatch(getEmployerList({ ...filterEmployer[2].params, page: page.current }));
    return () => {
      setItems([]);
      dispatch(resetGetVacancyList());
      dispatch(resetGetEmployerList());
      dispatch(resetGetStats());
      page.current = 1;
    };
  }, []);

  const sortModeration = (e) => {
    console.log(e.target.name);
    if (e.target.name === sortType) {
      setSortDirection(!sortDirection);
    } else {
      setSortType(e.target.name);
      setSortDirection(1);
    }

    if (e.target.name === 'date') {
      setSortDisplayName('по дате');
    } else if (e.target.name === 'reg') {
      setSortDisplayName('по рег данным');
    } else if (e.target.name === 'pay') {
      setSortDisplayName('по статусу оплаты');
    } else {
      setSortDisplayName('по менеджер');
    }
  };

  const sortPay = () => {
    setSortDirectionPay(!sortDirectionPay);
  };

  const goModeration = () => {
    localStorage.setItem('tabState', 'moderation');
    navigate('/vacancy');
  };

  const goApplicant = () => {
    localStorage.setItem('contractorTabState', 'applicant');
    navigate('/contractor');
  };

  const goApplicantDetail = () => {
    localStorage.setItem('contractorTabState', 'applicant');
    navigate('/detail');
  };
  const getActiveList = ({ loading, data, page, onNextPage }) => {
    return loading ? (
      <Skeleton height={364} />
    ) : !data?.results?.length ? (
      <VacancyEmpty style={{ height: '160px' }}>Пока нет активностей</VacancyEmpty>
    ) : (
      <>
        <div className="overflow-hidden">
          <table className="min-w-full divide-y divide-gray-200">
            <tbody className="divide-y divide-gray-200 ">
              {data?.results?.map((item) => (
                <tr key={item?.id}>
                  <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800 hidden md:block">{dayjs(item?.created_at)?.format('HH:mm DD.MM.YYYY')}</td>
                  <td className="px-2 py-2 underline whitespace-nowrap text-sm font-medium text-gray-800 ">
                    <Link to={`/user/${item?.employer?.id}`}>{item?.employer?.name}</Link>
                  </td>
                  <td className="px-2 py-2 underline whitespace-nowrap text-sm text-gray-800 flex flex-col gap-1">
                    <p className="block md:hidden">{dayjs(item?.created_at)?.format('HH:mm DD.MM.YYYY')}</p>
                    <Link to={item?.is_active && item?.is_verified ? `/moderation/${item?.id}` : `/activation/${item?.id}`}>{`${item?.id} - ${item?.name}`}</Link>
                  </td>
                  <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800 ">{item?.unprocessed_applications}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination
            style={{ marginTop: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            defaultCurrent={page}
            total={data?.count}
            showSizeChanger={false}
            current={page}
            // disabled={}
            onChange={onNextPage}
          />
        </div>
      </>
    );
  };

  return (
    <div className="w-full flex flex-1 mt-10 p-1">
      <div className="container relative flex flex-1 flex-col first:flex-row mx-auto max-w-[1163px]">
        <div className="flex flex-col w-full first:w-[67%] p-4 first:p-1 ">
          <p className="text-xl mb-5">Статистика</p>

          <div className="flex flex-wrap w-full gap-3 p-4 bg-white border-1 border-gray-200 shadow justify-between mb-5">
            <div className="flex items-center flex-col">
              <p className="text-[25px]">-</p>
              <p className="text-[14px] second:text-[16px]">активные</p>
              <p className="text-[14px] second:text-[16px]">соискатели</p>
            </div>
            <div className="flex items-center flex-col">
              <p className="text-[25px]">-</p>
              <p className="text-[14px] second:text-[16px]">новые</p>
              <p className="text-[14px] second:text-[16px]">соискатели</p>
            </div>
            <div className="flex items-center flex-col">
              <p className="text-[25px]">{getStatsLoading ? <Skeleton width="30px" height="30px" /> : getStatsData?.active}</p>
              <p className="text-[14px] second:text-[16px]">активные</p>
              <p className="text-[14px] second:text-[16px]">вакансии</p>
            </div>
            <div className="flex items-center flex-col">
              <p className="text-[25px]">{getStatsLoading ? <Skeleton width="30px" height="30px" /> : getStatsData?.moderation}</p>
              <p className="text-[14px] second:text-[16px]">вакансии</p>
              <p className="text-[14px] second:text-[16px]">на модерации</p>
            </div>
          </div>

          <div className="flex flex-row justify-between items-center mb-5">
            <p className="text-xl cursor-pointer flex items-center" onClick={goModeration}>
              На модерации {getStatsLoading ? <Skeleton width="30px" height="30px" className={'ml-1 translate-y-[-4px]'} /> : <>({getStatsData?.moderation})</>}
            </p>
            <div className="hs-dropdown relative inline-flex [--strategy:absolute]">
              <button id="hs-dropdown-right-but-left-on-lg" type="button" className="hs-dropdown-toggle flex flex-row items-center gap-x-2 text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov w-full md:w-auto transition ease-in-out duration-300">
                {sortDisplayName}
                {sortDirection ? <AscendingSvg color="#ffffff" /> : <DescendingSvg color="#ffffff" />}
              </button>

              <div className="hs-dropdown-menu w-60 transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden z-10 top-0 end-0 start-auto min-w-[10rem] bg-white shadow-md rounded-lg p-2 mt-2 " aria-labelledby="hs-dropdown-right-but-left-on-lg">
                <Link onClick={sortModeration} name="date" className="flex flex-row justify-between items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100">
                  по дате
                  {sortType === 'date' ? sortDirection ? <AscendingSvg color="#000000" /> : <DescendingSvg color="#000000" /> : ''}
                </Link>
                <Link onClick={sortModeration} name="reg" className="flex flex-row justify-between items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100">
                  по рег данным
                  {sortType === 'reg' ? sortDirection ? <AscendingSvg color="#000000" /> : <DescendingSvg color="#000000" /> : ''}
                </Link>
                <Link onClick={sortModeration} name="pay" className="flex flex-row justify-between items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100">
                  по статусу оплаты
                  {sortType === 'pay' ? sortDirection ? <AscendingSvg color="#000000" /> : <DescendingSvg color="#000000" /> : ''}
                </Link>
                <Link onClick={sortModeration} name="manager" className="flex flex-row justify-between items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100">
                  по менеджер
                  {sortType === 'manager' ? sortDirection ? <AscendingSvg color="#000000" /> : <DescendingSvg color="#000000" /> : ''}
                </Link>
              </div>
            </div>
          </div>

          <ModerationLists sortType={sortType} sortDirection={sortDirection} />

          <p className="text-xl mb-5">Активность</p>

          <div className="border-b border-gray-200 ">
            <nav className="flex space-x-2">
              <button
                type="button"
                className={clsx('px-1 inline-flex items-center gap-x-2 border-b-2  text-sm whitespace-nowrap hover:text-[#00B2A4] focus:outline-none focus:text-[#00B2A4]', activeTab == 'manager' ? 'text-[#00B2A4] font-semibold border-[#00B2A4]' : 'border-transparent text-gray-500 ')}
                onClick={() => {
                  setActiveTab('manager');
                }}>
                Менеджеры {activeManagerList?.loading ? <Skeleton height={20} width={20} style={{ transform: 'translateY(-2px)' }} /> : `(${activeManagerList?.data?.count})`}
              </button>
              <button
                type="button"
                className={clsx('px-1 inline-flex items-center gap-x-2 border-b-2 text-sm whitespace-nowrap hover:text-[#00B2A4] focus:outline-none focus:text-[#00B2A4]', activeTab == 'employers' ? 'text-[#00B2A4] font-semibold border-[#00B2A4]' : 'border-transparent text-gray-500 ')}
                onClick={() => {
                  setActiveTab('employers');
                }}>
                Работодатели {activeEmployersList?.loading ? <Skeleton height={20} width={20} style={{ transform: 'translateY(-2px)' }} /> : `(${activeEmployersList?.data?.count})`}
              </button>
            </nav>
          </div>

          <div className="mt-3">
            <div id="tabs-with-underline-1" role="tabpanel" aria-labelledby="tabs-with-underline-item-1" className="w-full bg-white border-1 border-gray-200 shadow mb-5">
              <div className="overflow-x-auto">
                <div className="p-4 min-w-full inline-block align-middle">
                  {activeTab == 'manager'
                    ? getActiveList({
                        ...activeManagerList,
                        page: managerPage,
                        onNextPage: (e) => {
                          setManagerPage(e);
                        },
                      })
                    : getActiveList({
                        ...activeEmployersList,
                        page: employerPage,
                        onNextPage: (e) => {
                          setEmployerPage(e);
                        },
                      })}
                  {}
                </div>
              </div>
            </div>
          </div>

          <div style={{ display: 'none' }} className="flex flex-row justify-between items-center mb-5">
            <p className="text-xl">Оплата</p>
            <button type="button" onClick={sortPay} className="flex flex-row items-center gap-x-2 text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov w-fit transition ease-in-out duration-300">
              по дате
              {sortDirectionPay ? <AscendingSvg color="#ffffff" /> : <DescendingSvg color="#ffffff" />}
            </button>
          </div>

          {/* <PaymentBlock sortDirection={sortDirectionPay} /> */}
        </div>
        <div className="flex flex-col w-full first:w-[33%] p-4 first:p-1  ">
          <p className="text-xl mb-5 cursor-pointer" onClick={goApplicant}>
            Заявки
          </p>
          {getEmployerListLoading && !items.length ? (
            <Skeleton height="403px" widht="100%" />
          ) : !items.length ? (
            <div className="w-full p-4 bg-white border-1 border-gray-200 shadow flex-col divide-y divide-solid ">
              <VacancyEmpty>Заявок нет</VacancyEmpty>
            </div>
          ) : (
            <div className="w-full p-4 bg-white border-1 border-gray-200 shadow flex-col divide-y divide-solid max-h-[403px] overflow-scroll" id="request-list">
              <InfiniteScroll
                dataLength={items.length}
                next={() => {
                  if (getEmployerListData?.next) {
                    page.current += 1;

                    dispatch(getEmployerList({ ...filterEmployer[2].params, page: page.current }));
                  }
                }}
                hasMore={true}
                scrollableTarget="request-list">
                {items?.map((item) => (
                  <>
                    <div
                      className="p-2 cursor-pointer"
                      onClick={() => {
                        navigate(`/user/${item.num}`);
                      }}>
                      <p className="text-[14px]">{item.date}</p>
                      <p className="text-[16px] font-bold ">{item.name}</p>
                    </div>
                    <hr />
                  </>
                ))}
              </InfiniteScroll>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DashboardIndex;
